import { SolicitudTiposEnum } from "./solicitud-tipos.enum";

export type Complementos = {
  [K in keyof typeof SolicitudTiposEnum]: Array<any>;
};

export class ComplementosModel {
  public complementos: Complementos[] = [];

  public esContratoConComplementos() {
    return this.complementos.length > 0;
  }
}